import type { SystemVersion } from "../shared/system-version";

declare const __VSIGN_BUILD_INFO__: SystemVersion;

export const BUILD_INFO: SystemVersion = typeof __VSIGN_BUILD_INFO__ === "undefined"
  ? { version: "0.0.0-development", revision: null, builtAt: null, sourceDigest: null, development: true }
  : __VSIGN_BUILD_INFO__;
